  import { Amplify } from '@aws-amplify/core';
  import { Auth } from '@aws-amplify/auth';

  class AuthUtilities {
    static expiryTimeValue = null;

    static refreshTokenPromise = null;

    static get expiryTime() {
      return this.expiryTimeValue.getTime();
    }

    static set expiryTime(expiryT) {
      if (expiryT instanceof Date) this.expiryTimeValue = expiryT;
      else this.expiryTimeValue = new Date(1000 * expiryT);
    }

    static async checkExpiryTime() {
      if (AuthUtilities.refreshTokenPromise) {
        const response = await AuthUtilities.refreshTokenPromise;
        return response;
      }
      const hasTokenExpired = new Date().getTime() + 60000 - AuthUtilities.expiryTime >= 0;
      if (hasTokenExpired) {
        const response = await AuthUtilities.refreshToken();
        return response;
      }
      return null;
    }

    static refreshToken = () => {
      AuthUtilities.refreshTokenPromise = new Promise((resolve, reject) => {
        Promise.all([Auth.currentAuthenticatedUser(), Auth.currentSession()])
          .then(([user, session]) => {
            if (session && session.refreshToken && user) {
              user.refreshSession(session.refreshToken, async (err, newSession) => {
                if (err) {
                  reject(err);
                }
                if (newSession) {
                  Amplify.configure({
                    API: {
                      graphql_headers: () => ({
                        Authorization: newSession.idToken.jwtToken,
                      }),
                    },
                  });
                }
                AuthUtilities.expiryTime = newSession.idToken.payload.exp;
                AuthUtilities.refreshTokenPromise = null;
                resolve('ok');
              });
            } else {
              reject(new Error('user/session not available'));
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
      return AuthUtilities.refreshTokenPromise;
    };

    static logoutUser = () => {
      localStorage.clear();
      if (window.parent && window.parent.window.location) window.parent.window.location.reload();
    };
  }

  export default AuthUtilities;
